import { createTransport } from "./transportFactory.js";

const { transport, baseUrl } = createTransport("invoices");

export const invoicesTransport = transport;
export const INVOICES_BASE_URL = baseUrl;

export class InvoiceLockedError extends Error {
  constructor(message) {
    super(message);
    this.name = "InvoiceLockedError";
    this.isInvoiceLocked = true;
  }
}

const cleanLockMessage = (msg) =>
  (msg || "Invoice is locked for this change")
    .replace(/\s*\(allowed:\s*\)/gi, "")
    .trim();

export const invoiceRequest = async (method, path, body = null) => {
  try {
    const config = { method, url: path };
    if (body !== null) config.data = body;
    const res = await invoicesTransport.request(config);
    return res.data;
  } catch (error) {
    if (error?.response?.status === 409) {
      throw new InvoiceLockedError(
        cleanLockMessage(error?.response?.data?.error),
      );
    }
    console.error(`InvoiceService ${method.toUpperCase()} ${path} failed:`, error);
    throw error;
  }
};
